<div class="d-flex align-items-center justify-content-between flex-wrap">
    <div class="fw-semibold">
        {{ title() }}
    </div>
    <div class="small text-muted">
        Entries: {{ workEntries().length }} · Conf. submitted:
        <span class="badge" [class.text-bg-success]="isSubmitted()" [class.text-bg-secondary]="!isSubmitted()">
            {{ isSubmitted() ? 'Yes' : 'No' }}
        </span>
    </div>
</div>

<accordion class="mt-2">
    <accordion-group heading="Entries ({{ workEntries().length }})" [isOpen]="workEntries().length > 0">
        @if (workEntries().length === 0) {
            <div class="text-muted small">No entries.</div>
        } @else {
            <div class="stack gap-2">
                @for (e of workEntries(); track $index) {
                    <pace-core-timesheet-entry-ngrx-spector
                        [entry]="e"
                        [addressesById]="addressesById()"
                    ></pace-core-timesheet-entry-ngrx-spector>
                    <hr class="my-2" />
                }
            </div>
        }
    </accordion-group>

    <accordion-group heading="Raw notification JSON">
        <pre class="small mb-0">{{ notification() | json }}</pre>
    </accordion-group>
</accordion>
